import { render, staticRenderFns } from "./siderDialog.vue?vue&type=template&id=81967d72&scoped=true&"
import script from "./siderDialog.vue?vue&type=script&lang=js&"
export * from "./siderDialog.vue?vue&type=script&lang=js&"
import style0 from "./siderDialog.vue?vue&type=style&index=0&id=81967d72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81967d72",
  null
  
)

export default component.exports